<template>
  <Suspense>
    <router-view />
    <template #fallback>
      <div class="fullscreen flex flex-center">
        <q-spinner-dots size="40" />
      </div>
    </template>
  </Suspense>
</template>

<script setup lang="ts">
// Import Tailwind CSS (required for @tailwindcss/vite plugin)
import 'src/css/tailwind.css'

import { storeToRefs } from 'pinia'
import { useQuasar } from 'quasar'
import { showErrorNotification } from 'src/CrudManager/Core/Utils/ToastNotification'
import { useGlobalStore } from 'src/CrudManager/Core/stores/useGlobalStore'
import { useUpdateStore } from 'src/CrudManager/Core/stores/useUpdateStore'
import { useUserStore } from 'src/CrudManager/Core/stores/useUserStore'
import { onMounted, onUnmounted, watchEffect } from 'vue'

const updateStore = useUpdateStore()
const globalStore = useGlobalStore()
const userStore = useUserStore()
const $q = useQuasar()

const { isDarkMode } = storeToRefs(globalStore)

watchEffect(() => {
  $q.dark.set(isDarkMode.value)
})

// Initialize the application
const initializeApp = async () => {
  try {
    await globalStore.initDarkMode()

    // Check for updates only in production
    if (import.meta.env.PROD) {
      await updateStore.checkForUpdates()
    }

    //if user is logged in, sync app data
    if (userStore.loggedIn) {
      await globalStore.syncAppData()
    }
  } catch (error) {
    console.error('Failed to initialize app:', error)
    showErrorNotification('Failed to initialize application', error)
  }
}

// Lifecycle hooks
onMounted(() => {
  initializeApp()
})

onUnmounted(() => {
  // Cleanup if needed
  globalStore.$reset()
  updateStore.$reset()
})
</script>

<style>
/* Add any global styles here */
.fullscreen {
  width: 100vw;
  height: 100vh;
}
</style>
